// Do nothing for now
module.exports = component => component;
